import { createSlice } from "@reduxjs/toolkit"
import dayjs from "dayjs"

const initialState = {
	paramData: {
		startDate: dayjs().subtract(6, 'day').format('YYYY-MM-DD'),
		endDate: dayjs().format('YYYY-MM-DD'),
		dateType: 'day'
	},
	totalParamData: {
		startDate: dayjs().subtract(6, 'day').format('YYYY-MM-DD'),
		endDate: dayjs().format('YYYY-MM-DD'),
		dateType: 'day',
		shopIdList: []
	}
}

const reducers = {
	setParamData: (state, action) => ({
		...state,
		paramData: {
			...state.paramData,
			...action.payload
		}
	}),
	setTotalParamData: (state, action) => ({
		...state,
		totalParamData: {
			...state.totalParamData,
			...action.payload
		}
	})
}

const robotQdataSlice = createSlice({
	name: 'robotQdata',
	initialState,
	reducers
})

export const {
	setParamData,
	setTotalParamData
} = robotQdataSlice.actions

export const getParamData = state => state.robotQdata.paramData
export const getTotalParamData = state => state.robotQdata.totalParamData

export default robotQdataSlice
